'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { toast } from 'sonner';

import { submitMealRating } from '@/features/meal-rating/actions/submitMealRatingAction';
import { getQueryKey } from '@/lib/tanstackQuery/queryRegistry';

interface UseSubmitMealRatingOptions {
  onSubmitted?: () => void;
}

export function useSubmitMealRating({ onSubmitted }: UseSubmitMealRatingOptions = {}) {
  const t = useTranslations('mealRating');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitMealRating,
    onSuccess: async () => {
      onSubmitted?.();
      toast.success(t('submitted'));
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: getQueryKey('employee-orders-history') }),
        queryClient.invalidateQueries({ queryKey: getQueryKey('employee-dashboard-today-meals') }),
        queryClient.invalidateQueries({ queryKey: getQueryKey('meal-rating-pending') }),
        queryClient.invalidateQueries({ queryKey: getQueryKey('meal-rating-stats') }),
        queryClient.invalidateQueries({ queryKey: getQueryKey('meal-rating-daily') }),
      ]);
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : t('submitError'));
    },
  });
}
